import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function PerformData({ id, plantName }) {
    const [performanceData, setPerformanceData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            axios
                .get(`https://backend-zkgn.onrender.com/api/performance/cogen/${id}`)
                .then(response => {
                    setPerformanceData(response.data || []);
                })
                .catch(error => {
                    console.error("Error fetching performance data:", error);
                })
                .finally(() => setLoading(false));
        }
    }, [id]);

    const handleDelete = async (performance_id) => {
        if (window.confirm("Are you sure you want to delete this entry?")) {
            try {
                await axios.delete(`https://backend-zkgn.onrender.com/api/performance/${performance_id}`);
                setPerformanceData(prev =>
                    prev.filter(data => data.performance_id !== performance_id)
                );
            } catch (error) {
                alert("Failed to delete. Please try again.");
                console.error("Error deleting entry:", error);
            }
        }
    };

    return (
        <div className="container-fluid my-5">
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <h4 className="fw-bold text-tertiary mb-2">Performance Data</h4>

                {/* ✅ Add Performance Button Always Visible */}
                <Link to={`/add-performance/${plantName}/${id}`} className="btn btn-primary mb-2">
                    + Add Performance
                </Link>
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : performanceData.length === 0 ? (
                <div className="alert alert-info">
                    No performance data found for this cogeneration plant.
                </div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-bordered performance-table table-sm">
                        <thead className="table-light">
                            <tr>
                                <th>Season</th>
                                <th>Bagasse Used (MT)</th>
                                <th>Power Generated (MW)</th>
                                <th>Power Exported (MW)</th>
                                <th>Operating Days</th>
                                <th className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {performanceData.map((data) => (
                                <tr key={data.performance_id}>
                                    <td>{data.season}</td>
                                    <td>{data.bgas_production}</td>
                                    <td>{data.total_ecity_prod}</td>
                                    <td>{data.total_ecity_export}</td>
                                    <td>{data.working_days}</td>

                                    <td className="text-end">
                                        {/* EDIT BUTTON */}
                                        <Link
                                            to={`/edit-performance/${data.performance_id}`}
                                            className="btn btn-link text-success me-3 p-0"
                                        >
                                            <i className="fa fa-edit"></i>
                                        </Link>

                                        {/* DELETE BUTTON */}
                                        <button
                                            className="btn btn-link text-danger p-0"
                                            onClick={() => handleDelete(data.performance_id)}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default PerformData;
